import { render, staticRenderFns } from "./MilestonesWidget.vue?vue&type=template&id=460f9bf3&"
import script from "./MilestonesWidget.vue?vue&type=script&lang=js&"
export * from "./MilestonesWidget.vue?vue&type=script&lang=js&"
import style0 from "./less/milestonesWidget.less?vue&type=style&index=0&module=%24&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$"] = (style0.locals || style0)
        Object.defineProperty(this, "$", {
          configurable: true,
          get: function () {
            return cssModules["$"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./less/milestonesWidget.less?vue&type=style&index=0&module=%24&lang=css&"], function () {
          var oldLocals = cssModules["$"]
          if (oldLocals) {
            var newLocals = require("./less/milestonesWidget.less?vue&type=style&index=0&module=%24&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("460f9bf3")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('460f9bf3')) {
      api.createRecord('460f9bf3', component.options)
    } else {
      api.reload('460f9bf3', component.options)
    }
    module.hot.accept("./MilestonesWidget.vue?vue&type=template&id=460f9bf3&", function () {
      api.rerender('460f9bf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/charts/MilestonesWidget.vue"
export default component.exports